$(document).ready(function () {
  hsize = $(window).height();
  $("#top_img_section").css("height", hsize + "px");
  });
  $(window).resize(function () {
  hsize = $(window).height();
  $("#top_img_section").css("height", hsize + "px");
});

$(document).ready(function () {
  wsize = $("#reservation_button").width();
  $(".right_side").css("width", wsize + "px");
  });
  $(window).resize(function () {
  wsize = $("#reservation_button").width();
  $(".right_side").css("width", wsize + "px");
});


    $(document).ready(function () {
    hsize = $(window).height();
    $("#about_top").css("height", hsize + "px");
    });
    $(window).resize(function () {
    hsize = $(window).height();
    $("#about_top").css("height", hsize + "px");
    });



$(function() {
  $('.carousel_type01').slick({
    autoplay: false,
    arrows: true,
    dots: true, // スライダー下部に表示される、ドット状のページネーションです
    infinite: true, // 無限ループ
    easing:"easeInOutExpo",
    speed: 800, // 切り替わりのスピード
    slidesToShow: 3, //通常 1024px以上の領域では4画像表示
    slidesToScroll: 1, 
    responsive: [
    {
      breakpoint: 600,settings: { //481px～600pxでは2画像表示
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,settings: {//480px以下では1画像表示
        centerMode:true,
        arrows: false,
        centerPadding:'0px',
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }]
  });

  //cart数量変更されたらリロード
$(document).on('change', '.cart__qty-input', function() {
//  alert("a");
  setTimeout(function(){location.reload();},1000);
});
  

});

$(function() {
  $('.carousel_type02').slick({
    autoplay: false,
    fade: true,
    arrows: false,
    dots: true, // スライダー下部に表示される、ドット状のページネーションです
    infinite: true, // 無限ループ
    easing:"easeInOutExpo",
    speed: 800, // 切り替わりのスピード
    slidesToShow: 1, //通常 1024px以上の領域では4画像表示
    slidesToScroll: 1
  });
});

$(function() {
  $('.carousel_type03').slick({
    autoplay: false,
    arrows: true,
    dots: true, // スライダー下部に表示される、ドット状のページネーションです
    infinite: true, // 無限ループ
    easing:"easeInOutExpo",
    speed: 800, // 切り替わりのスピード
    slidesToShow: 3, //通常 1024px以上の領域では4画像表示
    slidesToScroll: 1, 
    responsive: [
    {
      breakpoint: 600,settings: { //481px～600pxでは2画像表示
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,settings: {//480px以下では1画像表示
        centerMode:true,
        arrows: false,
        centerPadding:'30px',
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }]
  });
});
  


      $(function() {
          $('.carousel_type04').slick({
              autoplay: true,
              fade: true,
              arrows: false,
              dots: true, // スライダー下部に表示される、ドット状のページネーションです
              infinite: true, // 無限ループ
              easing:"easeInOutExpo",
              speed: 800, // 切り替わりのスピード
            autoplaySpeed: 6000,
              slidesToShow: 1, //通常 1024px以上の領域では4画像表示
              slidesToScroll: 1
          });
      });




      $(function() {
          $('.carousel_works').slick({
              autoplay: false,
              arrows: false,
              dots: true, // スライダー下部に表示される、ドット状のページネーションです
              infinite: true, // 無限ループ
              easing:"easeInOutExpo",
              speed: 800, // 切り替わりのスピード
              slidesToShow: 1, //通常 1024px以上の領域では4画像表示
              slidesToScroll: 1, 
              responsive: [

              {
                breakpoint: 480,settings: {//480px以下では1画像表示
                  arrows: false,
                  slidesToShow: 1,
                  slidesToScroll: 1
                }
              }]
          });
      });


$(window).on('scroll',function(){
var winPosTop = $(window).scrollTop();
if(winPosTop >= 100){
					$('.slide_text').addClass("active");
} else if(winPosTop < 100){
					$('.slide_text').removeClass("active");
}
});


			$(function(){
						setInterval(function(){
								$('.slide_text').fadeOut();
						},8000);
				});
				$(function(){
						setInterval(function(){
								$('.slide_text').fadeIn();
						},48000);
				});




$(window).load(function () {
  $('.loading').delay(400).fadeOut(1000);
});